import { useAppState } from '../../../AppStateProvider';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';

import {
  StyledContactCountry,
  StyledContactDetailsTooltip,
  StyledContactName,
  StyledContactPosition,
  StyledContactTooltip,
} from './styles';

export const ContactNameView = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();
  const { collectedContactInfo } = useAppState();
  const { name, companyName, title, country } = collectedContactInfo || {};
  const singleCompanyName =
    Array.isArray(companyName) && typeof companyName[0] === 'string' ? companyName[0] : companyName;

  const handleTooltipVisible = () => {
    dispatchTrackEventWithLocation('person data', 'hover', 'see person info');
  };

  return (
    <StyledContactTooltip
      minWidth={220}
      variant="white"
      debounce={300}
      onVisible={handleTooltipVisible}
      content={
        <StyledContactDetailsTooltip data-automation="ContactDetailsTooltip">
          <StyledContactPosition data-automation="ContactDetailsPosition">
            {title} at {singleCompanyName}
          </StyledContactPosition>
          <StyledContactCountry data-automation="ContactDetailsCountry">{country}</StyledContactCountry>
        </StyledContactDetailsTooltip>
      }
      data-automation="InsightsContactNameTooltip"
    >
      <StyledContactName data-automation="InsightsContactNameTooltip">{name}</StyledContactName>
    </StyledContactTooltip>
  );
};
